




import Vue from 'vue'
import Component from 'vue-class-component'
import ResidentStatements from '@/views/app/management/residents/resident-page/components/ResidentStatements.vue'

@Component({
  components: { ResidentStatements }
})
export default class ResidentStatementsTab extends Vue {
}
